import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppService {
public ApiUrl="https://bblticketapi.genuineitsolution.com/";//this.environments.server_url;//"https://bblticketapi.genuineitsolution.com/";//https://localhost:44312/";//"
public header: HttpHeaders;
public access_token="";
public token:string='';
public username:string='';
public empmastereditid:string='';
public usermastereditid:string='';
public checkereditdata:any={};
public isedit:boolean=false;
public referenceEditData:any=[];
isload:boolean=false;
public FinalApproverdata:any={};
public Editcheckerdata:string='';
public Editfinalapproverdata:any={};
public onboardinggriddata:any=[];
public onboardingeditid:string='';
public Itcreationemployeeid:any=[];
public hrclosuredata:any=[];
public hrclosureeditid:string='';
public referencegroupdata:any={};
public editchecker:string='';
public editfinalapprover:string='';
public edithrcloser:string='';
public ITfacility_empid:any=[];
public ITfacilityRejectionGrid:any=[];
public checkeritfacilityedit:string="";
public FinalIt_Facilitydata:any=[];
public FinalItfacilityeditid:string='';
public Microsoft360editid:string='';
public Microsoft360editdata:any={};
public Microsoft360finaldata:any={};
public Microsoft360finaleditid:string='';
public ItfacilityReject_editid:string='';
public checkeritfacilitygridedit:string='';
public microsoftrejecteditdata:string=''
public FinalItfacilityeditdata:string='';
public ITfacilitycheckerclosergrid:any=[];
public ITfacilitycheckerclosereditid:string='';
public Microsoft_360CheckerRejectgrid:any=[];
public Microsoft_checkRejecteditid:string='';
public CheckerID:string='';
public CheckerRevokeEdit:string='';
public FinalRevokeEdit:string='';
public Hrcloser_type :string='';
public ticketcreationid:string='';
public TicketEdituser:string='';
public Rights:string='';
public referenceEditDataid:string='';
  constructor(public toastr:ToastrService ,public http:HttpClient,public location:Location) {
    this.header = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    
   }
    getToken(username: string = 'admin', Password: string = 'admin'): Observable<string> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const body = `grant_type=password&UserName=${username}&Password=${Password}`;
    this.isload = true;

    return this.http.post<any>(`${this.ApiUrl}/token`, body, { headers })
      .pipe(
        map(response => {
          this.token = response.access_token;
          return this.token;
        }),
        catchError(error => {
          console.error('Token fetch error:', error);
          return throwError(() => new Error('Error fetching token'));
        })
      );
  }

  getMenuByModule(module: string) {
    return this.http.get<any[]>(
      `${this.ApiUrl}api/Transaction/Pr_get_Menus_byID?Rights=${module}`
    );
  }

  saveBulk(data: any[]) {
    return this.http.post<any>(
      `${this.ApiUrl}api/Transaction/insert_Menu_Master_Bulk`,
      data
    );
  }
  goback(){
    this.location.back();
  }
  public employeemasterdata:any[]=[]
  public checkeritfacilitygrid:any[]=[]
  getempployeemaster(){
    this.getTable("api/Master/getemployeedetails").subscribe((res:any)=>{
      this.employeemasterdata=res;
      console.log("the values",this.employeemasterdata);
      return this.employeemasterdata;
     // this.cdf.detectChanges();
        });
  }
 get_finalItFacilitygrid(){
  this.getTable("api/Transaction/getfinalITfacilitygrid").subscribe((res:any)=>{
    this.FinalIt_Facilitydata=JSON.parse(res).record;
    //console.log("the checkeritfacilitygrid",this.fin)
    return this.FinalIt_Facilitydata;
    
  });
 }
 get_Microsoft360_ITfacilitygrid(){
  this.getTable("api/Transaction/getMicrosoft360_ITfacilitygrid?id="+this.CheckerID).subscribe((res:any)=>{
    this.Microsoft360editdata=JSON.parse(res).record;
    
  //console.log("the checkeritfacilitygrid",this.Microsoft360editdata)
    //return this.Microsoft360editdata;
    
  });
 }
 
 GetMicrosoft360_checkerRejectedgrid(){
  this.getTable("api/Transaction/GetMicrosoft_checkerRejdata?id="+this.CheckerID).subscribe((res:any)=>{
    this.Microsoft_360CheckerRejectgrid=JSON.parse(res).record;
    
  //console.log("the checkeritfacilitygrid",this.Microsoft360editdata)
    //return this.Microsoft360editdata;
    
  });
 }
 getITfacilitycheckercloser_grid(){
  this.getTable("api/Transaction/pr_itfacility_checkercloser_grid").subscribe((res:any)=>{
    this.ITfacilitycheckerclosergrid=JSON.parse(res).record;
    
  //console.log("the checkeritfacilitygrid",this.Microsoft360editdata)
    //return this.Microsoft360editdata;
    
  });
 }
 get_Microsoft360_finalappgrid(){
  this.getTable("api/Transaction/getMicrosoft360_finalapprovergrid").subscribe((res:any)=>{
    this.Microsoft360finaldata=JSON.parse(res).record;
    //console.log("the checkeritfacilitygrid",this.fin)
    //return this.Microsoft360finaldata;
    
  });
 }
 
 get_Microsoft360_ITfacilityeditdata(id:any){
  this.getTable("api/Transaction/getMicrosoft360_ITfacilityeditdata?IR_Id="+id).subscribe((res:any)=>{
    if(res!=""){
      this.FinalItfacilityeditid=id;
      this.Editfinalapproverdata=JSON.parse(res).record[0];
      console.log("the Editfinalapproverdata",this.Editfinalapproverdata)
    }
    
  })
 }
  getcheckerITfacilitygrid(){
    this.getTable("api/Transaction/getcheckerITfacilitygrid?id="+this.CheckerID).subscribe((res:any)=>{
      this.checkeritfacilitygrid=JSON.parse(res).record;
      console.log("the checkeritfacilitygrid",this.checkeritfacilitygrid)
      return this.checkeritfacilitygrid;
      
    })
  }
  public Checkergriddata:any={}
  getcheckerdata(){
    this.getTable("api/Master/getcheckerdata?id="+this.CheckerID).subscribe((res:any)=>{
      if (typeof res === 'string') {
  try {
    // Remove control characters before parsing
    const clean = res.replace(/[\u0000-\u001F\u007F]/g, '');
    this.Checkergriddata = JSON.parse(clean);
  } catch (e) {
    console.error("Cleaned JSON parse error:", e);
    this.Checkergriddata = [];
  }
} else {
  this.Checkergriddata = res;
}
      //this.Checkergriddata=JSON.parse(res);
      //console.log("the values",this.Checkergriddata);
        });}
        
  //public employeeid:any=[];
//   getstaffid(){
//   this.getTable("Api/Transaction/Getstaffid").subscribe((res:any)=>{
//     this.employeeid=JSON.parse(res);
//     console.log("the values",this.employeeid);
//   })
// }

// formatCustomDate(dateString: string): string {
//   const [day, month, yearWithTime] = dateString.split('-');
//   const [year, time] = yearWithTime.split(' ');
//   return `${year}-${month}-${day}`; // returns '2025-09-01'
// }
formatCustomDate(dateString: string | null | undefined): string {
  if (!dateString) return '';

  let parsedDate: Date | null = null;
const noTime = dateString.split(' ')[0];
  // 1. Try native Date parsing first (handles "MM/dd/yyyy hh:mm:ss AM/PM")
  const tryNative = new Date(noTime);
  if (!isNaN(tryNative.getTime())) {
    parsedDate = tryNative;
  }

  // 2. If still invalid, check for "dd-MM-yyyy HH:mm:ss"
  if (!parsedDate) {
    const parts = dateString.split('-');
    if (parts.length === 3) {
      const [day, month, yearTime] = parts;
      const [year] = yearTime.split(' ');
      const iso = `${year}-${month}-${day}`;
      const tryIso = new Date(iso);
      if (!isNaN(tryIso.getTime())) {
        parsedDate = tryIso;
      }
    }
  }

  // 3. If everything fails
  if (!parsedDate) {
    console.warn('Invalid date received:', dateString);
    return '';
  }

  // Format into yyyy-MM-dd
  const year = parsedDate.getFullYear();
  const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
  const day = String(parsedDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}
public response:any=[]
getJsondata(res:any){
   if (typeof res === 'string') {
  try {
    // Remove control characters before parsing
    const clean = res.replace(/[\u0000-\u001F\u007F]/g, '');
    this.response = JSON.parse(clean);
  } catch (e) {
    console.error("Cleaned JSON parse error:", e);
    this.response = [];
  }
} else {
  this.response = res;
}
return this.response;
}
FinalApproverdatafetch(){
  this.getTable("api/Transaction/GetFinalApproverdata").subscribe((res:any)=>{
     if (typeof res === 'string') {
  try {
    // Remove control characters before parsing
    const clean = res.replace(/[\u0000-\u001F\u007F]/g, '');
    this.FinalApproverdata = JSON.parse(clean);
  } catch (e) {
    console.error("Cleaned on finalapprovalgrid JSON parse error:", e);
    this.FinalApproverdata = [];
  }
} else {
  this.FinalApproverdata = res;
}
   // this.FinalApproverdata=JSON.parse(res);
   // console.log("the values",this.FinalApproverdata);
      });}

// Employeeonbardinggrid(){
//   this.getTable("api/Transaction/Getemployeeonboarding").subscribe((res:any)=>{
//      if (Array.isArray(res) && res.length > 0) {
//     this.onboardinggriddata = res;
//     console.log("the onboardinggriddata", this.onboardinggriddata);
//   } else if (typeof res === 'string') {
//     try {
//       let parsed = JSON.parse(res);
//       if (Array.isArray(parsed) && parsed.length > 0) {
//         this.onboardinggriddata = parsed;
//         console.log("the onboardinggriddata", this.onboardinggriddata);
//       } else {
//         console.log("Parsed data is empty");
//       }
//     } catch (e) {
//       console.error("Error parsing response", e);
//     }
//   } else {
//     console.log("No data found or data is invalid");
//   }
//       });} ITfacilityRejectionGrid
public Microsoft_Rejectiongrid:any=[];
GetMicrosoft_Rejcet_details() {
  this.Microsoft_Rejectiongrid=[];
  this.getTable("api/Transaction/GetMicrosoft_Rejcet_details").subscribe((res: any) => {
    if (Array.isArray(res) && res.length > 0) {
      this.Microsoft_Rejectiongrid = res;
      console.log("the Microsoftgrid", this.Microsoft_Rejectiongrid);
    } else if (typeof res === 'string') {
      try {
        // Sanitize string before parsing
        const sanitized = res.replace(/[\u0000-\u001F\u007F]/g, ''); // Remove control characters
        let parsed = JSON.parse(sanitized);

        if (Array.isArray(parsed) && parsed.length > 0) {
          this.Microsoft_Rejectiongrid = parsed;
         console.log("the Microsoftgrid", this.Microsoft_Rejectiongrid);
        } else {
          console.log("Parsed data is empty");
        }
      } catch (e) {
        console.error("Error parsing response", e);
      }
    } else {
      console.log("No data found or data is invalid");
    }
  });
}
public CheckerITfacilityRejectiongrid:any=[];
public FinalItfacilityRejectiongrid:any=[];


checkerITfacilityRejectgrid() {
  this.CheckerITfacilityRejectiongrid=[];
  this.getTable("api/Transaction/GetCheckerItfacilityrej?id="+this.CheckerID).subscribe((res: any) => {
    if (Array.isArray(res) && res.length > 0) {
      this.CheckerITfacilityRejectiongrid = res;
      //console.log("the onboardinggriddata", this.onboardinggriddata);
    } else if (typeof res === 'string') {
      try {
        // Sanitize string before parsing
        const sanitized = res.replace(/[\u0000-\u001F\u007F]/g, ''); // Remove control characters
        let parsed = JSON.parse(sanitized);

        if (Array.isArray(parsed) && parsed.length > 0) {
          this.CheckerITfacilityRejectiongrid = parsed;
        //  console.log("the onboardinggriddata", this.onboardinggriddata);
        } else {
          console.log("Parsed data is empty");
        }
      } catch (e) {
        console.error("Error parsing response", e);
      }
    } else {
      console.log("No data found or data is invalid");
    }
  });
}


FinalitFacilityGrid() {
  this.FinalItfacilityRejectiongrid=[];
  this.getTable("api/Transaction/GetFinalItfacilityrej").subscribe((res: any) => {
    if (Array.isArray(res) && res.length > 0) {
      this.FinalItfacilityRejectiongrid = res;
      //console.log("the onboardinggriddata", this.onboardinggriddata);
    } else if (typeof res === 'string') {
      try {
        // Sanitize string before parsing
        const sanitized = res.replace(/[\u0000-\u001F\u007F]/g, ''); // Remove control characters
        let parsed = JSON.parse(sanitized);

        if (Array.isArray(parsed) && parsed.length > 0) {
          this.FinalItfacilityRejectiongrid = parsed;
        //  console.log("the onboardinggriddata", this.onboardinggriddata);
        } else {
          console.log("Parsed data is empty");
        }
      } catch (e) {
        console.error("Error parsing response", e);
      }
    } else {
      console.log("No data found or data is invalid");
    }
  });
}

ITfacilityrejectGrid() {
  this.ITfacilityRejectionGrid=[];
  this.getTable("api/Transaction/GetItfacilityReject_details").subscribe((res: any) => {
    if (Array.isArray(res) && res.length > 0) {
      this.ITfacilityRejectionGrid = res;
      //console.log("the onboardinggriddata", this.onboardinggriddata);
    } else if (typeof res === 'string') {
      try {
        // Sanitize string before parsing
        const sanitized = res.replace(/[\u0000-\u001F\u007F]/g, ''); // Remove control characters
        let parsed = JSON.parse(sanitized);

        if (Array.isArray(parsed) && parsed.length > 0) {
          this.ITfacilityRejectionGrid = parsed;
        //  console.log("the onboardinggriddata", this.onboardinggriddata);
        } else {
          console.log("Parsed data is empty");
        }
      } catch (e) {
        console.error("Error parsing response", e);
      }
    } else {
      console.log("No data found or data is invalid");
    }
  });
}
Employeeonbardinggrid() {
  this.onboardinggriddata=[];
  this.getTable("api/Transaction/Getemployeeonboarding").subscribe((res: any) => {
    if (Array.isArray(res) && res.length > 0) {
      this.onboardinggriddata = res;
      //console.log("the onboardinggriddata", this.onboardinggriddata);
    } else if (typeof res === 'string') {
      try {
        // Sanitize string before parsing
        const sanitized = res.replace(/[\u0000-\u001F\u007F]/g, ''); // Remove control characters
        let parsed = JSON.parse(sanitized);

        if (Array.isArray(parsed) && parsed.length > 0) {
          this.onboardinggriddata = parsed;
        //  console.log("the onboardinggriddata", this.onboardinggriddata);
        } else {
          console.log("Parsed data is empty");
        }
      } catch (e) {
        console.error("Error parsing response", e);
      }
    } else {
      console.log("No data found or data is invalid");
    }
  });
}
public ITfacilitygriddata:any=[];
public ItFacilityEditdata:any="";
IT_CreationGrid_Data() {
  this.ITfacilitygriddata=[];
  this.getTable("api/Transaction/Get_It_Facility_Grid_data").subscribe((res: any) => {
    if (Array.isArray(res) && res.length > 0) {
      this.ITfacilitygriddata = res;
      //console.log("the onboardinggriddata", this.onboardinggriddata);
    } else if (typeof res === 'string') {
      try {
        // Sanitize string before parsing
        const sanitized = res.replace(/[\u0000-\u001F\u007F]/g, ''); // Remove control characters
        let parsed = JSON.parse(sanitized);

        if (Array.isArray(parsed) && parsed.length > 0) {
          this.ITfacilitygriddata = parsed;
        //  console.log("the onboardinggriddata", this.onboardinggriddata);
        } else {
        
        }
      } catch (e) {
        console.error("Error parsing response", e);
      }
    } else {
     
    }
  });
}
post_data(data: any, Table: string) {
    //data.Company = this.Company;
    data.Created_by = this.username;
    data.Table_Name = Table;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    this.isload = true;
    this.http.post(this.ApiUrl + 'api/Master/Post_Data', data, { headers })
      .subscribe(
        (val: string) => {
          this.isload = false;
          return val;
        },
        response => {
          this.toastr.error('Error ', response, {
            timeOut: 3000
          });
          return "Error Contact Admin";
        });

    //return "Problem"
  }
  getItemployeeid(){
    this.getTable("Api/Transaction/GetemployeeidforIT_creation").subscribe((res:any)=>{
      this.Itcreationemployeeid=JSON.parse(res);
      //console.log("the values",this.employeeid);
    })
  }
  getreferencegroupvalues(){
    this.getTable("api/Master/Referencevalues").subscribe((res:any)=>{
      if(res!=''){
         if (typeof res === 'string') {
  try {
    // Remove control characters before parsing
    const clean = res.replace(/[\u0000-\u001F\u007F]/g, '');
    this.referencegroupdata = JSON.parse(clean);
  } catch (e) {
    console.error("Cleaned on referencegroupvalue JSON parse error:", e);
    this.referencegroupdata = [];
  }
} else {
  this.referencegroupdata = res;
}
        //this.referencegroupdata=JSON.parse(res);
      }
    });
  }
  public departmentdata:any=[];
  public Designationdata:any=[];
  public Locationdata:any=[];
  public plant:any=[];
  fetchplant(){
    this.plant=this.referencegroupdata.filter(item=>item.REM_REFid=='1');
    console.log('the plant are', this.plant)
    return this.plant;
  }
  fetchDesignation(){
    this.Designationdata=this.referencegroupdata.filter(item=>item.REM_REFid=='3');
  //console.log("the department data",this.departmentdata);
  return this.Designationdata;
  }
  fetchLocation(){
    this.Locationdata=this.referencegroupdata.filter(item=>item.REM_REFid=='4');
    console.log("the location",this.Locationdata);
    return this.Locationdata;
  }
  fetchDepartment(){
 this.departmentdata=this.referencegroupdata.filter(item=>item.REM_REFid=='2');
  console.log("the department data",this.departmentdata);
  return this.departmentdata;
  }
  public RequesterName="";
  // Get data table
  getTable1(endpoint: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'text/plain',
      'Authorization': `Bearer ${this.token}`
    });

    const url = `${this.ApiUrl}/${endpoint}`;

    return this.http.get<any>(url, { headers }).pipe(
      catchError(error => {
        console.error('Data fetch error:', error);
        return throwError(() => new Error('Error fetching table data'));
      })
    );}

    postTable(endpoint: string,payload: any): Observable<any> {
  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${this.token}`
  });

  const url = `${this.ApiUrl}/${endpoint}`;

  return this.http.post<any>(url, payload,{ headers }).pipe(
    catchError(error => {
      console.error('Data post error:', error);
      return throwError(() => new Error('Error posting table data'));
    })
  );
    }
    
public head: any;
public access_tocken = "";
  public tocken = "";
  get_Token() {
    this.head = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    this.isload = true;
    this.http.post(this.ApiUrl + 'token', 'grant_type=password&UserName=admin&Password=admin', { headers: this.head })
      .subscribe(
        (val:any) => {
          this.tocken = val['access_token'];
        },
        response => {
          this.toastr.error('Error ', response, {
            timeOut: 3000
          });
          return "Error Contact Admin";
        });}
getTable(url:any) { 
    this.access_tocken = this.tocken;
    var reqHeader = new HttpHeaders({
      'Content-Type': 'text/plain',
      'Authorization': 'Bearer ' + this.access_tocken
    });
    return this.http.get(this.ApiUrl + "" + url , { headers: reqHeader })
  }
  public ticketcreationdata:any=[]
    getticketcreationdata(){

        this.ticketcreationdata="";
        this.getTable("api/Transaction/Getticketcreationdata").subscribe((res:any)=>{
          this.ticketcreationdata=JSON.parse(res);
          console.log("the values",this.ticketcreationdata);
            });
      }
      public Ticket_StatusGrid:any=[]
       GetTicket_For_Status(){

        this.Ticket_StatusGrid="";
        this.getTable("api/Transaction/GetTicket_For_Status?id="+this.CheckerID).subscribe((res:any)=>{
          this.Ticket_StatusGrid=JSON.parse(res);
          // console.log("the values",this.ticketcreationdata);
            });
      }
gethrclosuredata(){
  this.hrclosuredata="";
  this.getTable("api/Transaction/GetemployeeidforHRcloser").subscribe((res:any)=>{
    this.hrclosuredata=JSON.parse(res);
    //console.log("the values",this.hrclosuredata);
      });}

      GetOffboardingDetails(){
  this.hrclosuredata="";
  this.getTable("api/Transaction/GetHRcloserOffboardingGrid").subscribe((res:any)=>{
    this.hrclosuredata=JSON.parse(res);
    //console.log("the values",this.hrclosuredata);
      });}
       GetRolechangeDetails(){
  this.hrclosuredata="";
  this.getTable("api/Transaction/Get_RolechangeGrid").subscribe((res:any)=>{
    this.hrclosuredata=JSON.parse(res);
    //console.log("the values",this.hrclosuredata);
      });}
getITfacility_empid(){
this.ITfacility_empid=[];
this.getTable('api/Transaction/GetITfacilityempId').subscribe((res:any)=>{
  this.ITfacility_empid=JSON.parse(res);
  
})
}
  //  get_Token() {
  //   this.header = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
  //   this.isload = true;
  //   this.http.post(this.ApiUrl + 'token', 'grant_type=password&UserName=admin&Password=admin', { headers: this.header })
  //     .subscribe(
  //       (val) => {
  //         this.token = val['access_token'];
  //       },
  //       response => {
  //         console.error('Error ', response, {
  //           timeOut: 3000
  //         });
  //         return "Error Contact Admin";
  //       });
  //   //return "Problem"
  // }
  // gettable(url){
  // this.access_token=this.token
  // var reqHeaders= new HttpHeaders({
  //    'Content-Type': 'text/plain',
  //     'Authorization': 'Bearer ' + this.access_token
  // });
  // return this.http.get(this.ApiUrl+""+url+"&Company=" ,{ headers: reqHeaders })
  // }

}
